import React from "react";
import TextInput from "@src/components/form/input/TextInput";
import "./number-input.scss";


const NumberInput = (props: any) => {
  const {
      step = 1,
      min = Number.MIN_SAFE_INTEGER,
      max = Number.MAX_SAFE_INTEGER,
      value = "0",
      onChange
  } = props;

  const handleIncrement = () => {
      const newValue = Math.min(Number(value) + step, max);
      onChange?.(newValue.toString());
  };

  const handleDecrement = () => {
      const newValue = Math.max(Number(value) - step, min);
      onChange?.(newValue.toString());
  };

  return (
      <div className="NumberInput">
          <TextInput
              {...props}
              type="number"
              value={value}
              onChange={onChange}
          />
          <div className="NumberInput__buttons">
            <button type="button" onClick={handleIncrement} className="NumberInput-button increment"><i className="cinicon-angle-up"></i></button>
            <button type="button" onClick={handleDecrement} className="NumberInput-button decrement"><i className="cinicon-angle-down"></i></button>
          </div>
      </div>
  );
};

export default NumberInput;
